<template>
  <div class="sidebar-profile">
    <div class="user-info">
      <div class="user-avatar">
        <img
          v-if="currentUser?.avatar"
          :src="currentUser.avatar"
          alt="User Avatar"
          @click="router.push('/profile/info')"
        />

        <img
          v-else
          src="@/assets/images/user-icon.png"
          class="ms-2 photo"
          @click="router.push('/profile/info')"
        />
      </div>
      <div class="user-details">
        <p class="account-label">Аккаунт</p>
        <a :href="currentUser.email" class="user-email">{{
          currentUser.email
        }}</a>
      </div>
    </div>
    <div class="divider"></div>
    <nav class="menu mt-2">
      <ul>
        <li v-for="(item, index) in sidebarList" :key="index">
          <router-link
            :to="item.link"
            custom
            v-slot="{ href, navigate, isActive }"
          >
            <a
              :href="href"
              class="menu-link px-4"
              :class="{ active: isActive }"
              @click.prevent="onMenuClick(item, navigate)"
            >
              <div class="icon-block">
                <img :src="item.icon" />
                <span
                  v-if="item.title === 'Сообщения' && hasUnreadMessages"
                  class="unread-dot"
                ></span>
              </div>
              {{ item.title }}
            </a>
          </router-link>
        </li>
        <li>
          <a class="menu-link px-4" @click="logout()" active-class="active">
            <img src="@/assets/images/icons/logout.svg" class="me-4" /> Выйти
          </a>
        </li>
      </ul>
    </nav>
    <BuyASubscriptionWarningModal ref="subscriptionWarningModal" />
  </div>
</template>

<script>
import chatRoom from "@/services/chatRoom";
import { defineComponent, ref, computed, onMounted } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { sidebarList } from "@/models/sidebar";
import { isUnreadRoom } from "@/utils/messages";
import BuyASubscriptionWarningModal from "@/components/Modals/BuyASubscriptionWarningModal.vue";

export default defineComponent({
  name: "ProfileSidebar",
  components: { BuyASubscriptionWarningModal },
  setup() {
    const fileInput = ref(null);
    const router = useRouter();
    const store = useStore();
    const currentUser = computed(() => store.state.user.user);
    const hasUnreadMessages = computed(() => store.state.chats.hasUnread);

    const subscriptionWarningModal = ref(null);

    const restrictedTitles = ["Сообщения", "Друзья", "Корзина"];

    const isLimitedUser = computed(() => {
      const membership = currentUser?.value?.name_membership;
      return !membership || membership === "Free";
    });

    const onMenuClick = (item, navigate) => {
      if (isLimitedUser?.value && restrictedTitles.includes(item.title)) {
        subscriptionWarningModal?.value?.openModal();
        return;
      }
      navigate();
    };

    onMounted(async () => {
      try {
        if (
          currentUser?.value?.name_membership &&
          currentUser?.value?.name_membership !== "Free"
        ) {
          const rooms1 = await chatRoom.getAll();
          const rooms2 = await chatRoom.getFriendsAllChats();
          const allRooms = [...rooms1, ...rooms2];

          const hasUnread = allRooms.some((room) =>
            isUnreadRoom(room, currentUser?.value?.id)
          );

          store.commit("chats/setHasUnread", hasUnread);
        }
      } catch (e) {
        console.error("Failed to init unread state in sidebar", e);
      }
    });

    const logout = async () => {
      await store.dispatch("auth/logout");
      router.push("/");
    };

    return {
      fileInput,
      currentUser,
      sidebarList,
      router,
      logout,
      hasUnreadMessages,
      subscriptionWarningModal,
      onMenuClick,
    };
  },
});
</script>

<style lang="scss">
@import "@/assets/styles/profile/sidebar.scss";
</style>
